import { getAllData } from "apis/customApiHandler";
import Spinner from "components/Spinner";
import Model from "components/Modal";
import { Form, FormikProvider, useFormik } from "formik";
import { Fragment, useCallback, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useQuery, useQueryClient } from "react-query";
import { useSelector } from "react-redux";
import { Button } from "styled";
import { TD, TH } from "styled/table";
import ReactSelect from "react-select";
import { BiTransfer } from "react-icons/bi";
import { IoMdArrowBack, IoMdArrowForward } from "react-icons/io";
import axios from "apis/axios";

const IGRNApproval = () => {
  const currentUser = useSelector((state) => state.user.currentUser);
  const qClient = useQueryClient();
  const [page, setPage] = useState(1);
  const formik = useFormik({
    initialValues: {
      fleetId: "",
    },
    onSubmit: async (values) => {
      try {
        const res = await axios({
          method: "POST",
          url: `/fleetRoute/getIGRN?fleetId=${formik.values.fleetId}&status=Pending`,
          data: {
            ...values,
          },
        });
        qClient.invalidateQueries("/getIGRN");
      } catch (error) {
        console.log(error);
      }
    },
  });
  console.log("fleetId", formik.values.fleetId)
  const { data: tyres, isLoading } = useQuery(
    [`/getIGRN`, formik.values.fleetId && formik.values.fleetId],
    () =>
      getAllData(`/fleetRoute/getIGRN`, {
        status: "Pending",
      }),
    {
      enabled: !!formik.values.fleetId,
      refetchInterval: null,
    }
  );

  const { data: allFleets } = useQuery([`/customer-fleet`], () =>
    getAllData("/customer-fleet", {
      limit: 3000,
    })
  );

  const { data: IGRNs } = useQuery([`/getIGRN`], () =>
    getAllData(`/fleetRoute/getIGRN`, {
      status: "Pending",
    })
  );

  const getFleetOptions = useCallback(() => {
    if (allFleets && allFleets.data && allFleets.data.length) {
      return [
        ...allFleets?.data?.map((fleet) => {
          return {
            value: fleet._id,
            label: fleet.fleetName,
          };
        }),
      ];
    }
  }, [allFleets]);

  return (
    <div>
      <div className="mx-10 my-2">
        <div className="mt-8 flex justify-start gap-6 items-center flex-wrap lg:flex-nowrap">
          <label className=" w-full">
            Select Fleet
            <ReactSelect
              options={getFleetOptions()}
              value={{
                value: formik.values.fleetId,
                label: getFleetOptions()?.find(
                  (fleet) => fleet.value === formik.values.fleetId
                )?.label,
              }}
              onChange={(value) => {
                formik.setFieldValue("fleetId", value.value);
              }}
              name="fleetId"
              placeholder="Select Fleet"
            />
            {formik.touched.fleetId && formik.errors.fleetId ? (
              <p className="text-red-500 font-normal">
                *{formik.errors.fleetId}
              </p>
            ) : null}
          </label>
        </div>
      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        <div className="flex flex-col m-2 lg:m-10">
          <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
              <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <TH scope="col">S.N.</TH>
                      <TH scope="col">Customer Type</TH>
                      <TH scope="col">Fleet Code</TH>
                      <TH scope="col">Fleet Status</TH>
                      <TH scope="col">Manufacturer</TH>
                      <TH scope="col">Type Make</TH>
                      <TH scope="col">Tyre Pattern</TH>
                      <TH scope="col">Stencil Numbers</TH>
                      <TH scope="col">Tyre Makes</TH>
                      <TH scope="col">Tyre Sizes</TH>
                      <TH scope="col">Action</TH>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {IGRNs?.data?.igrn &&
                      IGRNs?.data.igrn.map((item, index) => (
                        <ViewList
                          data={item}
                          key={item?._id}
                          index={index}
                          formik={formik}
                        />
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {IGRNs?.data?.totalPage > 1 && (
            <div className="container mx-auto flex justify-center items-center gap-2 py-5">
              <Button
                onClick={() => setPage((p) => Math.max(p - 1, 1))}
                disabled={page === 1}
                className="disabled:pointer-events-none disabled:opacity-70 px-0 "
                primary
              >
                <div className="flex gap-1 items-center">
                  <IoMdArrowBack />
                  Prev Page
                </div>
              </Button>
              <span className="text-gray-600 px-4">{page}</span>

              <Button
                onClick={() =>
                  setPage((p) => Math.min(p + 1, IGRNs.data?.pageInfo?.total))
                }
                disabled={page === IGRNs.data?.pageInfo?.total}
                className="disabled:pointer-events-none disabled:opacity-70 px-0 "
                primary
              >
                <div className="flex gap-1 items-center">
                  Next Page
                  <IoMdArrowForward />
                </div>
              </Button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default IGRNApproval;

const ViewList = ({ data, index, formik }) => {
  const stencilNumbers = [];
  const tyreMakes = [];
  const tyreSizes = [];
  const currentUser = useSelector((state) => state.user.currentUser);
  const queryClient = useQueryClient();
  data?.tyres?.map((tyre) => {
    if (tyre.tyres) {
      if (tyre.tyres.stencil) {
        stencilNumbers.push(tyre.tyres.stencil);
      }
      if (tyre.tyres.tyreMake) {
        tyreMakes.push(tyre.tyres.tyreMake);
      }
      if (tyre.tyres.tyreSize) {
        tyreSizes.push(tyre.tyres.tyreSize);
      }
    }
  });
  const approveRejectHandler = (isApproved) => {
    axios({
      url: "/fleetRoute/updateIGRN",
      method: "PUT",
      headers: {
        Authoriztaion: `Bearer ${currentUser.token}`,
      },
      data: {
        grnId: data._id,
        status: isApproved ? "Approved" : "Rejected",
      },
      baseURL: `${process.env.REACT_APP_API_URL}`,
    })
      .then((res) => {
        toast.success("Successfully saved");
        queryClient.invalidateQueries("/getIGRN");
      })
      .catch((err) => {
        toast.error(err.response.data);
      });
  };
  return (
    <Fragment>
      <tr key={data._id} className={`${index % 2 !== 0 && "bg-gray-100"}`}>
        <TD>{index + 1}</TD>
        <TD>{data.customerType}</TD>
        <TD>{data?.fleetId}</TD>
        <TD>{data?.fleetStatus}</TD>
        <TD>{data.manufacturer}</TD>
        <TD>{data?.typeMake}</TD>
        <TD>{data?.tyrePattern}</TD>
        <TD>{stencilNumbers.length > 0 && stencilNumbers.join(", ")}</TD>
        <TD>{tyreMakes.length > 0 && tyreMakes.join(", ")}</TD>
        <TD>{tyreSizes.length > 0 && tyreSizes.join(", ")}</TD>
        <TD>
          <Button
            onClick={() => approveRejectHandler(true)}
            className="p-2 m-1  rounded-md bg-green-500 hover:bg-green-600 text-white"
          >
            Approve
          </Button>
          <Button
            onClick={() => approveRejectHandler(false)}
            className="p-2  m-1 rounded-md bg-red-500 hover:bg-red-600 text-white"
          >
            Reject
          </Button>
        </TD>
      </tr>
    </Fragment>
  );
};
